import React, { useEffect } from 'react';
import ReactDom from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import moment from 'moment';
import { ConfigProvider } from 'antd';
import i18n from './language';
import { BaseProvider, store } from './store';
import wtmonitor from './wutang-monitor.js';
import { ENV_CONFIG } from './constants';
// import { currentLanguage } from '@meiqia/language';
import { closePerspectiveMode, isPerspectiveMode, removeCookie } from './utils';

import './styles/index.less';
import './sentry';

import zh from 'antd/lib/locale/zh_CN';
// import tw from 'antd/lib/locale/zh_TW';
// import en from 'antd/lib/locale/en_GB';
// import th from 'antd/lib/locale/th_TH';
// import vi from 'antd/lib/locale/vi_VN';
// import id from 'antd/lib/locale/id_ID';
// import ms from 'antd/lib/locale/ms_MY';
// import hi from 'antd/lib/locale/hi_IN';
// import ja from 'antd/lib/locale/ja_JP';
// import pt from 'antd/lib/locale/pt_BR';
// import es from 'antd/lib/locale/es_ES';
// import ru from 'antd/lib/locale/ru_RU';
// import kr from 'antd/lib/locale/ko_KR';
// import my from './language/antd-locales/my'; //缺少缅甸语需要自己补充
// import km from './language/antd-locales/km'; //缺少柬埔寨语需要自己补充
// import fil from './language/antd-locales/fil'; //缺少菲律宾语需要自己补充
// import fr from 'antd/lib/locale/fr_FR';
// import lo from './language/antd-locales/lo'; //缺少老挝语需要自己补充
// import nl from 'antd/lib/locale/nl_NL';
// import de from 'antd/lib/locale/de_DE';
// import ar from 'antd/lib/locale/ar_EG';
// import bn from './language/antd-locales/bn'; //缺少孟加拉语需要自己补充
// import tr from 'antd/lib/locale/tr_TR';
// import fa from 'antd/lib/locale/fa_IR';
// import it from 'antd/lib/locale/it_IT';
// import pl from 'antd/lib/locale/pl_PL';
// import zu from './language/antd-locales/zu'; //缺少祖鲁语需要自己补充

import 'moment/locale/zh-cn';
// import 'moment/locale/zh-tw';
// import 'moment/locale/en-gb';
// import 'moment/locale/th';
// import 'moment/locale/vi';
// import 'moment/locale/id';
// import 'moment/locale/ms-my';
// // import 'moment/locale/hi';
// import 'moment/locale/ja';
// import 'moment/locale/pt-br';
// import 'moment/locale/es';
// import 'moment/locale/ko';
// // import 'moment/locale/my';
// // import 'moment/locale/km';
// import 'moment/locale/tl-ph';
// import 'moment/locale/fr';
// import 'moment/locale/lo';
// import 'moment/locale/nl';
// import 'moment/locale/de';
// // import 'moment/locale/ar';
// // import 'moment/locale/bn';
// import 'moment/locale/tr';
// // import 'moment/locale/fa';
// import 'moment/locale/it';
// import 'moment/locale/pl';
//缺少祖鲁语
// moment.locale('zu', {
//   months: 'Januwari_Febhuwari_Mashi_Aplili_Meyi_Juni_Julayi_Agasti_Sitimba_Oktoba_Novemba_Disemba'.split('_'),
//   monthsShort: 'Jan_Feb_Mar_Apr_Mey_Jun_Jul_Aga_Sit_Okt_Nov_Dis'.split('_'),
//   weekdays: 'ISonto_Umzulu_Ulwesibili_Ulwesithathu_Ulwesine_Ulwesihlanu_Umgqibelo'.split('_'),
//   weekdaysShort: 'Son_Mso_Mbl_Umt_Utn_Ukh'.split('_'),
//   weekdaysMin: 'So_Mo_Tu_We_Th_Fr_Sa'.split('_'),
//   longDateFormat: {
//     LT: 'HH:mm',
//     LTS: 'HH:mm:ss',
//     L: 'DD/MM/YYYY',
//     LL: 'D MMMM YYYY',
//     LLL: 'D MMMM YYYY HH:mm',
//     LLLL: 'dddd, D MMMM YYYY HH:mm'
//   },
//   calendar: {
//     sameDay: '[Namhlanje kuya] LT',
//     nextDay: '[Kusasa kuya] LT',
//     nextWeek: 'dddd [kuya] LT',
//     lastDay: '[Itolo kuya] LT',
//     lastWeek: '[Icawe kuya] dddd [kuya] LT',
//     sameElse: 'L'
//   },
//   relativeTime: {
//     future: 'emva kwesikhathi %s',
//     past: '%s kudala',
//     s: 'emizuzwana',
//     ss: '%d izuzwana',
//     m: 'umzuzu',
//     mm: '%d izuzu',
//     h: 'lihora',
//     hh: '%d amahora',
//     d: 'usuku',
//     dd: '%d izinsuku',
//     M: 'inyanga',
//     MM: '%d izinyanga',
//     y: 'umnyaka',
//     yy: '%d iminyaka'
//   },
//   dayOfMonthOrdinalParse: /\d{1,2}ko/,
//   ordinal: '%dko',
//   week: {
//     dow: 1, // Monday is the first day of the week.
//     doy: 4 // The week that contains Jan 4th is the first week of the year.
//   }
// });

if (process.env.NODE_ENV !== 'production') {
  if (module.hot) {
    module.hot.accept();
  }
}

import Route from './routes';

wtmonitor();

// const configLanguage = () => {
//   const language = currentLanguage();
//   if (language === 'cht') {
//     return { antd: tw, moment: 'zh-tw' };
//   } else if (language === 'en') {
//     return { antd: en, moment: 'en-gb' };
//   } else if (language === 'th') {
//     return { antd: th, moment: 'th' };
//   } else if (language === 'vi') {
//     return { antd: vi, moment: 'vi' };
//   } else if (language === 'id') {
//     return { antd: id, moment: 'id' };
//   } else if (language === 'ms') {
//     return { antd: ms, moment: 'ms-my' };
//   } else if (language === 'hi') {
//     return { antd: hi, moment: 'hi' };
//   } else if (language === 'ja') {
//     return { antd: ja, moment: 'ja' };
//   } else if (language === 'pt') {
//     return { antd: pt, moment: 'pt-br' };
//   } else if (language === 'es') {
//     return { antd: es, moment: 'es' };
//   } else if (language === 'ru') {
//     return { antd: ru, moment: 'ru' };
//   } else if (language === 'ko') {
//     return { antd: kr, moment: 'ko' };
//   } else if (language === 'my') {
//     return { antd: my, moment: 'my' };
//   } else if (language === 'km') {
//     return { antd: km, moment: 'km' };
//   } else if (language === 'fil') {
//     return { antd: fil, moment: 'tl-ph' };
//   } else if (language === 'fr') {
//     return { antd: fr, moment: 'fr' };
//   } else if (language === 'lo') {
//     return { antd: lo, moment: 'lo' };
//   } else if (language === 'nl') {
//     return { antd: nl, moment: 'nl' };
//   } else if (language === 'de') {
//     return { antd: de, moment: 'de' };
//   } else if (language === 'ar') {
//     return { antd: ar, moment: 'ar' };
//   } else if (language === 'bn') {
//     return { antd: bn, moment: 'bn' };
//   } else if (language === 'tr') {
//     return { antd: tr, moment: 'tr' };
//   } else if (language === 'fa') {
//     return { antd: fa, moment: 'fa' };
//   } else if (language === 'it') {
//     return { antd: it, moment: 'it' };
//   } else if (language === 'pl') {
//     return { antd: pl, moment: 'pl' };
//   } else if (language === 'zu') {
//     return { antd: zu, moment: 'zu' };
//   }
//   return { antd: zh, moment: 'zh-cn' };
// };
moment.locale('zh-cn');

const RECAPTCHA_SCRIPT = 'laigu_recaptch';

// 全局promise 异常捕获
window.addEventListener('unhandledrejection', function(e) {
  e.preventDefault();
  console.log('捕获到异常：', e);
  return true;
});

// 清除旧的cookie
if (document.location.hostname !== 'localhost') {
  const expires = new Date();
  expires.setTime(expires.getTime() - 1);

  document.cookie = `_agent_id=123; expires=${expires.toGMTString()}`;
  document.cookie = `_enterprise_id=123; expires=${expires.toGMTString()}`;
  document.cookie = `_authenticated=123; expires=${expires.toGMTString()}`;
}

const App = () => {
  useEffect(() => {
    if (window.CUSTOM_CONFIG && !window.CUSTOM_CONFIG[window.CUSTOM_NAME].recaptcha) return;
    if (!document.getElementById(RECAPTCHA_SCRIPT)) {
      const recaptchaNode = document.createElement('script');
      recaptchaNode.id = RECAPTCHA_SCRIPT;
      recaptchaNode.src = `https://www.recaptcha.net/recaptcha/api.js?render=${ENV_CONFIG.RECAPTCHA_KEY}`;
      recaptchaNode.defer = true;
      document.body.appendChild(recaptchaNode);
    }
    document.body.style.overflowX = 'hidden';
    return () => {
      const node = document.getElementById(RECAPTCHA_SCRIPT);
      if (node) {
        document.body.removeChild(node);
      }
      document.body.style.overflowX = 'unset';
    };
  }, []);

  useEffect(() => {
    const beforeunload = () => {
      if (isPerspectiveMode()) {
        removeCookie('_enterprise_id');
        removeCookie('_agent_id');
        removeCookie('_authenticated');
        closePerspectiveMode();
      }
    };
    window.addEventListener('beforeunload', beforeunload);
    return () => {
      window.removeEventListener('beforeunload', beforeunload);
    };
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <BaseProvider store={store}>
        <ConfigProvider locale={zh}>
          <Route />
        </ConfigProvider>
      </BaseProvider>
    </I18nextProvider>
  );
};

ReactDom.render(<App />, document.getElementById('main'));
